/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_LabelInputs */

const en_services_label = /** @type {(inputs: Services_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI automation services`)
};

const lv_services_label = /** @type {(inputs: Services_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI automatizācijas pakalpojumi`)
};

/**
* | output |
* | --- |
* | "AI automation services" |
*
* @param {Services_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_label = /** @type {((inputs?: Services_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_label(inputs)
	return en_services_label(inputs)
});